import React from 'react';

import { Helmet } from "react-helmet";

import { CssBaseline, Container } from "@material-ui/core"
import { responsiveFontSizes, createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

import {
  HashRouter as Router,
  Switch,
  Route
} from "react-router-dom";

import { Home, StyleGuide, Animations, Queerify } from "./Pages"
import Videos from "./Videos"

import Navigation from "./Components/Navigation"

/* Theme */
let theme = createMuiTheme({
  typography: {

  }
});
theme = responsiveFontSizes(theme);

/* App */
function App() {
  // Add class to body so we can hide some elements from embedding page
  const body = document.getElementsByTagName("body")[0]
  body.classList.add("erw-plugin")

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <Helmet>
          <meta name="viewport" content="width=device-width, initial-scale=1"></meta>
        </Helmet>

        <Router basename="/queerdenker-festival-2-0">
          <Switch>
            <Container fixed>
              <Navigation />

              <Videos />

              <Route path="/queerify">
                <Queerify />
              </Route>
              <Route path="/animations">
                <Animations />
              </Route>
              <Route path="/style">
                <StyleGuide />
              </Route>
              <Route exact path="/">
                <Home />
              </Route>
            </Container>

            
          </Switch>
        </Router>
      </div>
    </ThemeProvider>
  );
}

export default App;
